import { useEffect, useMemo, useState } from "react";
import {
  getKonaseemaGuide,
  getTripPlannerData,
  loadGuideContent,
  subscribeGuide,
  type KonaseemaGuide,
  type TripPlannerData,
} from "@/lib/publicGuide";

/** Re-renders subscribers whenever the guide content finishes loading. */
function useGuideTick(): number {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let active = true;
    const unsubscribe = subscribeGuide(() => {
      if (active) setTick((value) => value + 1);
    });
    loadGuideContent();
    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return tick;
}

/** Konaseema travel-guide content, read from the backend with curated fallback. */
export function useKonaseemaGuide(): KonaseemaGuide {
  const tick = useGuideTick();
  return useMemo(() => getKonaseemaGuide(), [tick]);
}

/** Trip-planner pool, filters and presets, read from the backend. */
export function useTripPlannerData(): TripPlannerData {
  const tick = useGuideTick();
  return useMemo(() => getTripPlannerData(), [tick]);
}